import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { LinkRounded } from '@mui/icons-material';
import { Button, Stack, Typography, alpha } from '@mui/material';

interface DashboardShareDrawerCopyLinkProps {
  onCopyDashboardLink: () => void;
}

export const DashboardShareDrawerCopyLink = ({
  onCopyDashboardLink,
}: DashboardShareDrawerCopyLinkProps) => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  if (!dashboard.id) {
    return null;
  }
  return (
    <Stack direction="row" spacing={1} px={4}>
      <Stack
        bgcolor={(theme) => alpha(theme.palette.primary.main, 0.08)}
        width={36}
        height={36}
        alignItems="center"
        justifyContent="center"
        borderRadius="50%"
      >
        <LinkRounded color="primary" />
      </Stack>
      <Stack spacing={2}>
        <Typography marginTop={0.5}>Copy Link to Dashboard</Typography>

        <Typography variant="caption" color="text.disabled">
          You can share this link with anyone in your organization to view this
          Dashboard.
        </Typography>
        <Button
          variant="outlined"
          startIcon={<LinkRounded />}
          sx={{ width: 'fit-content' }}
          onClick={onCopyDashboardLink}
        >
          Copy Link
        </Button>
      </Stack>
    </Stack>
  );
};
